module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/cocktail_452174.jpg";